import React from "react";
import PhoneInput from "../ui/PhoneInput";

const FirstForm = ({
  phoneNumber,
  countryCode,
  onPhoneNumberChange,
  onCountryCodeChange,
  handleNext,
  step
}) => {
  return (
    <PhoneInput
      countryCodes={["+1", "+91"]}
      countryCode={countryCode}
      phoneNumber={phoneNumber}
      onPhoneNumberChange={onPhoneNumberChange}
      onCountryCodeChange={onCountryCodeChange}
      handleNext={handleNext}
      step={step}
    />
  );
};
export default FirstForm;
